import AbstractSymbolSpineAnimationsConfig from "../../vendor_core/core/src/baseConfigs//AbstractSymbolSpineAnimationsConfig";
import ISymbolSpineAnimConfig from "../../vendor_core/core/src/managers/contracts/configurations/ISymbolSpineAnimConfig";
import ISpineAnimSkinConfig from "../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimSkinConfig";
import ISpineAnimStateConfig from "../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimStateConfig";

class SymbolSpineAnimationsConfig
    extends AbstractSymbolSpineAnimationsConfig
    implements ISymbolSpineAnimConfig
{
    name: string = "symbols";
    hasSkins: boolean = true;
    defaultSkin: string = "default";
    activeSkin: string = "default";
    visible: boolean = true;
    states: ISpineAnimStateConfig[] = [
        {
            name: "idle",
            loop: true,
        },
        {
            name: "end",
            loop: false,
        },
        {
            name: "win",
            loop: false,
        },
        {
            name: "darken",
            loop: false,
        },
        {
            name: "landing",
            loop: false,
        },
        {
            name: "fade",
            loop: false,
        },
        {
            name: "dark",
            loop: false,
        },
        {
            name: "coin_tranform",
            loop: false,
        },
        {
            name: "coin_rain_transform",
            loop: false,
        },
        {
            name: "coin_feature",
            loop: false,
        },
        {
            name: "coin_appear",
            loop: false,
        },
        {
            name: "coin_skull",
            loop: false,
        },
        {
            name: "idle_skull",
            loop: true,
        },
    ];
    skins: ISpineAnimSkinConfig[] = [
        {
            name: "default",
            states: [],
        },
        {
            name: "F9",
            states: ["idle", "win", "coin_tranform", "coin_rain_transform"],
            playDefault: true,
            defaultState: "idle",
            chainingStates: [
                {
                    name: "win_tr",
                    entryPoint: "win",
                    hasLoopStateOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "",
                    states: ["win", "coin_tranform"]
                }
            ]
        },
        {
            name: "F8",
            states: ["idle", "win", "coin_tranform", "coin_rain_transform"],
            playDefault: true,
            defaultState: "idle",
            chainingStates: [
                {
                    name: "win_tr",
                    entryPoint: "win",
                    hasLoopStateOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "",
                    states: ["win", "coin_tranform"]
                }
            ]
        },
        {
            name: "F7",
            states: ["idle", "win", "coin_tranform", "coin_rain_transform"],
            playDefault: true,
            defaultState: "idle",
            chainingStates: [
                {
                    name: "win_tr",
                    entryPoint: "win",
                    hasLoopStateOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "",
                    states: ["win", "coin_tranform"]
                }
            ]
        },
        {
            name: "F6",
            states: ["idle", "win", "coin_tranform", "coin_rain_transform"],
            playDefault: true,
            defaultState: "idle",
            chainingStates: [
                {
                    name: "win_tr",
                    entryPoint: "win",
                    hasLoopStateOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "",
                    states: ["win", "coin_tranform"]
                }
            ]
        },
        {
            name: "F5",
            states: ["idle", "win", "coin_tranform", "coin_rain_transform"],
            playDefault: true,
            defaultState: "idle",
            chainingStates: [
                {
                    name: "win_tr",
                    entryPoint: "win",
                    hasLoopStateOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "",
                    states: ["win", "coin_tranform"]
                }
            ]
        },
        {
            name: "M1",
            states: ["idle", "win", "coin_tranform", "coin_rain_transform"],
            playDefault: true,
            defaultState: "idle",
            chainingStates: [
                {
                    name: "win_tr",
                    entryPoint: "win",
                    hasLoopStateOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "",
                    states: ["win", "coin_tranform"]
                }
            ]
        },
        {
            name: "M2",
            states: ["idle", "win", "coin_tranform", "coin_rain_transform"],
            playDefault: true,
            defaultState: "idle",
            chainingStates: [
                {
                    name: "win_tr",
                    entryPoint: "win",
                    hasLoopStateOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "",
                    states: ["win", "coin_tranform"]
                }
            ]
        },
        {
            name: "M3",
            states: ["idle", "win", "coin_tranform", "coin_rain_transform"],
            playDefault: true,
            defaultState: "idle",
            chainingStates: [
                {
                    name: "win_tr",
                    entryPoint: "win",
                    hasLoopStateOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "",
                    states: ["win", "coin_tranform"]
                }
            ]
        },
        {
            name: "M4",
            states: ["idle", "win", "coin_tranform", "coin_rain_transform"],
            playDefault: true,
            defaultState: "idle",
            chainingStates: [
                {
                    name: "win_tr",
                    entryPoint: "win",
                    hasLoopStateOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "",
                    states: ["win", "coin_tranform"]
                }
            ]
        },
        {
            name: "BN",
            states: ["idle", "win", "landing"],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "CN",
            states: ["idle", "win", "landing", "coin_feature"],
            playDefault: true,
            defaultState: "idle",
            chainingStates: [
                {
                    name: "skull",
                    entryPoint: "coin_skull",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "idle_skull",
                    states: ["coin_skull", "idle_skull"]
                }
            ]
        },
    ];
}

export default new SymbolSpineAnimationsConfig();
